// Stateful components

export function ModalSection(props){


    // Render

    var modal_data = props['modal_data'];
    var modal_content = modal_data['content'];
    var modal_buttons = props['buttons'];

    return (
        <>
            <div className="modal__section">
                {modal_content}
            </div>
            <div className="modal__buttons">
                {modal_buttons}
            </div>
        </>
    );
}
